module.exports = __webpack_public_path__ + "img/desktop_white.72ed0f9d.svg";